import {
  PDC_SET_PAGINATION,
  PDC_SET_SORT,
  PDC_INIT,
  PDC_SET_KEY_FILTER_SELECTED,
  PDC_SET_CURRENT_FILTERS
} from "./../types";
export const getPdcs = data => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setPagination(data.page, state.pdcs.pages));
  };
};

export const init = () => {
  return (dispatch, getState) => {
    const state = getState();
    const currentFilters = {
      ...state.pdcs.currentFilters,
      // "sectors.client_id": state.currentClient && state.currentClient.id // uncheck secto only checkbox by default
    };

    dispatch({ type: PDC_INIT });
    dispatch(setCurrentFilters(currentFilters));
    dispatch(getPdcs({ filters: currentFilters, page: 1 }));
  };
};
export const setSort = data => {
  return { type: PDC_SET_SORT, data };
};
export const setPagination = (page, pages) => ({
  type: PDC_SET_PAGINATION,
  page,
  pages
});

export const setCurrentFilters = currentFilters => ({
  type: PDC_SET_CURRENT_FILTERS,
  currentFilters
});

export function updateFiltersFront(key, filters) {
  return (dispatch, getState) => {
    const state = getState();
    const currentFilters = state.pdcs.currentFilters || {};
    if (key === "sectors.client_id") {
      filters ? (currentFilters[key] = state.currentClient.id) : delete currentFilters[key];
    } else {
      if (filters && filters.length && filters.length !== 0) {
        currentFilters[key] = filters;
      } else {
        delete currentFilters[key];
      }
    }
    dispatch(setCurrentFilters(currentFilters));
    dispatch(getPdcs({ filters: currentFilters, page: 1 }));
  };
}
export const setKeyFilterSelected = key => {
  return {
    type: PDC_SET_KEY_FILTER_SELECTED,
    key
  };
};



// WEBPACK FOOTER //
// src/redux/actions/pdcActions.js